import { createContext, useContext, type ReactNode } from "react";

type Translate = (key: string, fallback: string, variables?: Record<string, string | number>) => string;

const I18nContext = createContext<Translate>((_key, fallback) => fallback);

export function I18nProvider({ translations, children }: { translations: Record<string, string>; children: ReactNode }) {
  const translate: Translate = (key, fallback, variables = {}) => {
    let value = translations[key] ?? fallback;
    Object.entries(variables).forEach(([name, replacement]) => {
      value = value.replaceAll(`{${name}}`, String(replacement));
    });
    return value;
  };
  return <I18nContext.Provider value={translate}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
